import styled from 'styled-components';

export const StyledAboutPage = styled.div`
  .about-page {
    width: 100%;

    &__main-section {
    }

    &__our-services-section {
      margin-top: 80px;
      background-color: ${({ theme }) => theme.colors.concrete};
    }

    &__our-products-section {
      margin-top: 120px;
    }
  }
`;
